// Screen `document-template-editor` — plan §9.12 — owner: doc-templates. The document template editor
// in the focus layout (no app rail): pages, masters, bands, data and publishing.
import { createFileRoute } from '@tanstack/react-router';
import { TemplateEditorPage } from '../../../features/doc-templates/TemplateEditor';

export const Route = createFileRoute('/_focus/documents/$id')({
  component: DocumentTemplateRoute,
});

function DocumentTemplateRoute() {
  const { id } = Route.useParams();
  return <TemplateEditorPage key={id} id={id} />;
}
